<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >

    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="col-lg-12">
            <bita-formgroup title="اطلاعات" class="row px-3">
              <bita-input
                type="text"
                name="title"
                label="عنوان"
                rules="required"
                :validation-container-class="colWidth"
                input-class="form-control"
                v-model="form.title"
              />

              <bita-texteditor
                type="text"
                name="description"
                ref="content"
                label="توضیحات"
                validation-container-class="col-12"
                input-class="form-control"
                v-model="form.description"
              />
            </bita-formgroup>

            <bita-formgroup title="تاریخ" class="row px-3">
              <bita-datepicker
                type="datetime"
                id="publish_at"
                rules="required"
                :validation-container-class="colWidth"
                name="publish_at"
                label="تاریخ انتشار"
                inputClass="form-control"
                class="ml-2"
                v-model="form.publish_at"
                format="YYYY-MM-DD HH:mm:ss"
                display-format="jYYYY/jMM/jDD HH:mm:ss"
              />

              <bita-datepicker
                type="datetime"
                id="expire_at"
                rules="required|after:@تاریخ انتشار"
                :validation-container-class="colWidth"
                name="expire_at"
                label="مهلت مشارکت"
                inputClass="form-control"
                v-model="form.expire_at"
                format="YYYY-MM-DD HH:mm:ss"
                display-format="jYYYY/jMM/jDD HH:mm:ss"
              />

                            <bita-datepicker
                type="datetime"
                id="review_at"
                rules="required|after:@تاریخ انتشار"
                :validation-container-class="colWidth"
                name="expire_at"
                label="تاریخ بررسی و اطلاع رسانی"
                inputClass="form-control"
                v-model="form.review_at"
                format="YYYY-MM-DD HH:mm:ss"
                display-format="jYYYY/jMM/jDD HH:mm:ss"
              />

            </bita-formgroup>

            <bita-formgroup title="بیشتر" class="row">

              <bita-input
                name="min_participation"
                rules="required"
                ref="min_participation"
                label="حداقل میزان مشارکت"
                :validation-container-class="colWidth"
                input-class="form-control"
                data-text-field="name"
                data-value-field="id"
                v-model="form.min_participation"
              />
                 <bita-input
                name="max_participation"
                rules="required"
                ref="max_participation"
                label="حداکثر میزان مشارکت"
                :validation-container-class="colWidth"
                input-class="form-control"
                data-text-field="name"
                data-value-field="id"
                v-model="form.max_participation"
              />
                 <bita-input
                name="amount_payable"
                rules="required"
                ref="amount_payable"
                label="مبغ پرداختی"
                :validation-container-class="colWidth"
                input-class="form-control"
                data-text-field="name"
                data-value-field="id"
                v-model="form.amount_payable"
                :has-thousand-seprator="true"

              />
              <bita-uploader
                name="thumbnail"
                label="تصویر"
                ref="uploader"
                rules="size:50"
                :validation-container-class="colWidth"
                input-class="form-control"
                v-model="form.thumbnail"
                :icon-url="form.thumbnail_url"
              />

            

             
            </bita-formgroup>
            <bita-formgroup title="گزینه ها" class="row">
            <label class="col-4 align-self-center">
              <input
                type="checkbox"
                v-model="form.show_participation"

              />
              نمایش میزان مشارکت در خروجی
            </label>

            <label class="col-4 align-self-center">
              <input
                type="checkbox"
                v-model="form.early_release"
              
              />
              انتشار زودتر از موعد کمپین
            </label>




            </bita-formgroup>
            <bita-formgroup title="محصول" class="row">
                <bita-multiselect 
                  name="product_id"
                  label="محصول"
                  ref="product_id "
                  validation-container-class="col-lg-6 col-md-12 col-sm-12"
                  rules="required"
                  input-class="form-control"
                 :data-source="products"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="form.product_id"
                  
                />
                

            </bita-formgroup>
          </div>
        </div>
      </bita-form>
      <div slot="footer">
        <bita-bootbutton
          v-if="!propsData.id"
          type="primary"
          title="ذخیره"
          icon="fa fa-check"
          btn-width="150px"
          @click.native="handleSubmit()"
        />
        <bita-bootbutton
          v-if="propsData.id"
          type="primary"
          title="بروزرسانی"
          icon="fa fa-check"
          btn-width="150px"
          @click.native="handleSubmit()"
        />
        <bita-bootbutton
          class="mr-2"
          type="danger"
          title="بستن"
          icon="fas fa-times"
          btn-width="150px"
          data-dismiss="modal"
          @click.native="
            () => {
              $emit('change-status-modal');
            }
          "
        />
      </div>
    </div>
  </bita-modal>
</template>

<script>
export default {
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    propsData: {},
    propsProducts: [],
  },
  data() {
    return {
      colWidth: "col-lg-4",
      form: {},
      products: [],
    };
  },
  watch: {
    propsData: function(_data) {
      if (!!_data.id) {
        this.form = { ..._data };
        this.form.thumbnail_url = this.form.thumbnail;
        this.form.thumbnail = "";
        this.form.show_participation = !!Number(this.form.show_participation);
        this.form.early_release = !!Number(this.form.early_release);
        this.form.product_id = _data.products.map(p => p.id);
      } else {
        this.form = {
          title: "",
          description: "",
          publish_at: "",
          expire_at: "",
          review_at: "",
          amount_payable:"",
          show_participation:false,
          early_release:false,
          amount_payable:"",
          thumbnail: "",
          thumbnail_url: "",
           product_id: [], 
          products: [],
        };
      }
    },
    propsProducts: function(_data) {
      this.products = _data;
    },

  },
  methods: {

    toggleLoading() {
      this.$emit("isLoading");
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.form.description = this.form.description.replaceAll(/( {2})/g, "");
           this.form.show_participation = this.form.show_participation ? 1 : 0;
           this.form.early_release = this.form.early_release ? 1 : 0;
          this.$emit("on-submit", this.form);
        }
      });
    },
    onCloseModal() {
      this.$refs.form.reset();
    },
  },
};
</script>
